import { Patient } from "../../model/patient/Patient";
import { parsePatient } from "../../parsers/patient/parsePatient";
import { api } from "../api";

export const getPatient = async (id: string): Promise<Patient> => {
  const response = await api.services.patient.getPatient(id);
  const responseDetail = await api.services.patient.getPatientDetail(id);
  return parsePatient(response.data, responseDetail.data);
};
